import React from "react";
import "./privacy.css";
import Header from "../header";
import Footer from "../footer";
const Privacy = () => {
  return (
    <div>
		<Header/>
        <div className="mt-5">
            <div className="container">
                <div className="dataBoxxInfo">
                    <h3>Privacy Policy</h3>
                    <p>The Money Laundry ("we", "our", "us") is committed to safeguarding the confidentiality and security of our customers, website, and mobile app users ("you", "your"). We declare that your personal information will not be disclosed to any third party unless required to provide a service to you. By accessing our website/app, you acknowledge reading and understanding this Privacy Policy and agree to be bound by its terms.</p>
                    <div><span className="washingLiner"></span></div>
                </div>
                <div className="perfectInfoFooter mb-5">
                <div className="row featurette">
    <div className="col-sm-12">
        <div className="info-hsn">
            {/* <p>
                Published on 28th June 2021 This is as Agreement Between you or the entity that you represent (hereinafter “You” or “Your”) and Money Laundry TECHNOLOGIES PVT. LTD. (hereinafter “Money Laundry”) Governing your use of Money Laundry suite of
                online Business.
            </p> */}
        </div>
        <div className="info-hsn">
            <h2>Cookies: </h2>
            <p>
            Our website uses cookies to distinguish users and enhance your experience. Cookies help us improve our site and services. For detailed information on the cookies we use, please refer to our Cookie Policy at www.themoneylaundry.in/cookies.
            </p>
            <p>Information We Collect and How We Use It:</p>
            <p>We collect and use your information for the following purposes:</p>
            <p>To register you as a customer and provide you with our services.</p>
            <p>To fulfill our contractual obligations and provide you with requested products and services.</p>
            <p>To notify you about changes to our services.</p>
            <p>To inform you about other similar goods and services that may be of interest to you.</p>
            <p>To request your participation in surveys and service reviews.</p>
            <p>To deliver relevant website content, app data, and advertisements, and measure their effectiveness.</p>

        </div>
        <div className="info-hsn">
            <h2>Your Consent:</h2>
            <p>We will not sell or rent your personal information (name, location, email, phone number, payment details) to any third party without your consent. However, we reserve the right to disclose information when legally required. We are not responsible for third-party actions that may have directed you to our website or app.</p>
        </div>
        <div className="info-hsn">
            <h2>Communication & Marketing:</h2>
            <p>By registering on our platform, you agree to receive promotional emails, notifications, and messages regarding offers, new services, or changes in service timings. If you wish to opt out of such communications, you can unsubscribe via the provided link or contact us at contactus@themoneylaundry.in</p>
        </div>
        <div className="info-hsn">
            <h2>Protecting Your Security:</h2>
            <p>Your information is stored securely. If you have a password for accessing certain sections of our website/app, you are responsible for keeping it confidential. While we take stringent security measures, data transmission over the internet is not entirely secure, and we cannot guarantee complete protection.</p>
        </div>
        <div className="info-hsn">
            <h2>Data Retention:</h2>
            <p>If you contact us but do not enter into a contract, your data will be deleted after two years.</p>
            <p>If you become our customer, we retain contract-related information for six years after contract termination or as required by law.</p>
        </div>
        <div className="info-hsn">
            <h2>Disclosure of Information:</h2>
            <p>We may share your details with fraud prevention agencies for anti-fraud checks, but this does not affect your credit rating. We may also share information with partner entities to facilitate joint services like pickup and delivery. Additionally, we may use third-party providers to serve ads and analyze site traffic.</p>
        </div>
        <div className="info-hsn">
            <h2>Usage of Demographic and Profile Data:</h2>
            <h2>We use your data to:</h2>
            <p>1. Provide the requested services.</p>
            <p>2. Resolve disputes and troubleshoot issues.</p>
            <p>3. Enhance safety and security.</p>
            <p>4. Measure consumer interest in our services.</p>
            <p>5. Inform you about offers, products, and updates.</p>
            <p>6. Conduct optional online surveys.</p>
            <p>7. You can opt out of marketing communications at any time. We will always obtain your explicit consent before sharing your data with third parties for marketing purposes.</p>
        </div>
        <div className="info-hsn">
            <h2>Your Rights:</h2>
            <p>Under applicable data protection laws, you have the right to:</p>
            <p>1. Access your personal data.</p>
            <p>2. Opt out of data processing for marketing purposes.</p>
            <p>3. Withdraw consent for data processing.</p>
            <p>4. Request corrections to inaccurate data.</p>
            <p>5. Request data deletion where processing is no longer necessary.</p>
            <p>6. Request data transfer in a machine-readable format.</p>
            <p>7. Withdraw consent for the use of your name or image in promotions.</p>
            <p>To exercise your rights, contact us at <a className="textDecor" href="mailto:contactus@themoneylaundry.in">contactus@themoneylaundry.in </a></p>
        </div>
        <div className="info-hsn">
            <h2>Third-Party Links:</h2>
            <p>Our website and app may contain links to third-party websites. These sites have independent privacy policies, and we are not responsible for their practices. Please review their policies before submitting any personal information.</p>
        </div>
        <div className="info-hsn">
            <h2>Changes to Privacy Policy:</h2>
            <p>We may update this Privacy Policy at any time. The revised policy takes effect immediately upon posting. Please review this page periodically for updates.</p>
        </div>
        <div className="info-hsn">
        <h2>For any queries, contact our customer support team at <a className="textDecor" href="mailto:contactus@themoneylaundry.in">contactus@themoneylaundry.in</a>.</h2>
        </div>
    </div>
</div>

                </div>
            </div>
        </div>
		<Footer/>
    </div>
  );
};

export default Privacy;
